import { render, staticRenderFns } from "./subjectlist.vue?vue&type=template&id=b943dc44&scoped=true&"
import script from "./subjectlist.vue?vue&type=script&lang=js&"
export * from "./subjectlist.vue?vue&type=script&lang=js&"
import style0 from "./subjectlist.vue?vue&type=style&index=0&id=b943dc44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b943dc44",
  null
  
)

export default component.exports